export default {"src":"/_next/static/media/crust.5b444dcd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};